define('lq/style',[
    'jquery',
    'underscore',
    'lq',
    'lq/util'
], function ($, _, lq, util) {
    'use strict';

    var defaultSupportedFontFamilies = [
        { name: 'Arial,Arial,Helvetica,sans-serif', pdf: true },
        { name: 'Arial Black,Arial Black,Gadget,sans-serif', pdf: true },
        { name: 'Comic Sans MS,Comic Sans MS,cursive', pdf: true },
        { name: 'Courier New,Courier New,Courier,monospace', pdf: true },
        { name: 'Georgia,Georgia,serif', pdf: true },
        'Impact,Charcoal,sans-serif',
        'Lucida Console,Monaco,monospace',
        'Lucida Sans Unicode,Lucida Grande,sans-serif',
        'Palatino Linotype,Book Antiqua,Palatino,serif',
        'Tahoma,Geneva,sans-serif',
        { name: 'Times New Roman,Times,serif', pdf: true },
        { name: 'Trebuchet MS,Helvetica,sans-serif', pdf: true },
        { name: 'Verdana,Geneva,sans-serif', pdf: true },
        { name: 'Gill Sans MT,Gill Sans,Geneva,sans-serif', pdf: true },
        'TheSans, sans-serif',
        'Abril Fatface, cursive',
        'Asap',
        'Autour One, cursive',
        'Avenir Book, sans-serif',
        'Avenir, sans-serif',
        'Avenir Roman, sans-serif',
        'Average Sans, sans-serif',
        'Bad Script, cursive',
        'Bellerose, sans-serif',
        'Cabin, sans-serif',
        'Cambo, serif',
        'CantoraOne, sans-serif',
        'Carrois Gothic SC, sans-serif',
        'Chela One, cursive',
        'Chewy, cursive',
        'Combo, cursive',
        'Days One, sans-serif',
        'Didact Gothic, sans-serif',
        'Droid Sans, sans-serif',
        'Fascinate, cursive',
        'Faster One, cursive',
        '"HelveticaNeueLT", sans-serif',
        'Hind, sans-serif',
        'FontAwesome, cursive',
        'Gravity, sans-serif',
        'Iceland, cursive',
        'Kavoon, cursive',
        'Market Deco, sans-serif',
        'Meie Script, cursive',
        'Merriweather Sans, sans-serif',
        'Microsoft YaHei, sans-serif',
        'Noto Serif CJK SC, serif',
        'Noto Sans CJK SC, sans-serif',
        'Nunito, sans-serif',
        'Oleo Script Swash Caps, cursive',
        'Open Sans, sans-serif',
        'Open Sans Condensed, sans-serif',
        'Patrick Hand SC, cursive',
        'Paulistana Deco, sans-serif',
        'PT Sans, sans-serif',
        'Quando, serif',
        'Quicksand, sans-serif',
        'Raleway, sans-serif',
        'Roboto, sans-serif',
        'Roboto Slab, serif',
        'Shojumaru, cursive',
        'Sofadi One, cursive',
        'Strong Glasgow, sans-serif',
        'Swanky and Moo Moo, cursive',
        '"Swiss 721 Extended", sans-serif',
        'Titillium Web, sans-serif',
        'Unkempt, cursive',
        'Lato, sans-serif',
        'Montserrat, sans-serif'
    ];

    var supportedTextAligns = [
        'left',
        'center',
        'right',
        'justify'
    ];

    var supportedFontWeights = [
        {key: '400', value: 'normal'},
        {key: '100', value: 'thin'},
        {key: '200', value: 'extra light'},
        {key: '300', value: 'light'},
        {key: '500', value: 'medium'},
        {key: '600', value: 'semi bold'},
        {key: '700', value: 'bold'},
        {key: '800', value: 'extra bold'},
        {key: '900', value: 'black'}
    ];

    var supportedTextTransforms = [
        'none',
        'capitalize',
        'uppercase',
        'lowercase'
    ];

    var supportedHorizontalPositions = [
        'left',
        'center',
        'right'
    ];

    var supportedVerticalPositions = [
        'top',
        'center',
        'bottom'
    ];

    var defaults = {

        enabled: false,

        border: {
            top: false,
            right: false,
            bottom: false,
            left: false,
            style: 'solid',
            color: 'rgba(0, 0, 0, 1)',
            width: 1,
            customDashedBorder: {
                dash: 5,
                gap: 5,
                dashCap: 'round',
                radiusEnabled: false,
                radius: 0,
            }
        },

        font: {
            size: 14,
            fontFamily: defaultSupportedFontFamilies[0].name,
            color: 'rgba(0, 0, 0, 1)',
            inheritColor: false,
            weight: supportedFontWeights[0].key,
            italic: false,
            underline: false
        },

        text: {
            align: supportedTextAligns[0],
            verticalAlign: 'top',
            lineHeight: '',
            textTransform: supportedTextTransforms[0]
        },

        background: {
            enabled: false,
            color: 'rgba(255, 255, 255, 1)'
        },

        backgroundStripes: {
            enabled: false,
            color: 'rgb(0, 0, 0)',
            width: 1,
            gap: 4,
            angle: 45,
        },

        padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        },

        boxShadow: {
            enabled: false,
            x: 4,
            y: 4,
            blur: 5,
            spread: 0,
            color: 'rgba(0, 0, 0, 1)'
        },

        textShadow: {
            enabled: false,
            x: 4,
            y: 4,
            blur: 5,
            color: 'rgba(0, 0, 0, 1)'
        },

        textStroke: {
            enabled: false,
            color: 'rgba(0, 0, 0, 1)',
            size: 0
        },

        opacity: 100,

        roundedCorners: {
            enabled: false,
            leftTopRadius: 0,
            rightTopRadius: 0,
            rightBottomRadius: 0,
            leftBottomRadius: 0
        },

        scrollbarGutter: 'auto',

        scrollBehavior: 'auto',

        backgroundImage: {
             leftMargin: 0,
             rightMargin: 0
        },

        heading: {
            enabled: false,
            level: 1,
            numberingStyle: 'numeric'
        },

		rotate: 0,

        runtime: false
    };

    var Style = function () {
    };

    Style.prototype.defaultStyles = [];
    Style.prototype.defaultMockStyles = [];

    var customStyleStates = ['dragTarget', 'dragHover', 'selected', 'active', 'normal'];

    Style.prototype.renderStyles = function (drop, classPrefix, $actualElement, actualStyle, customState, customHoverStyle, $requiredIndicatorElement) {
        if (!$actualElement)
            $actualElement = drop.$element;
        if (!actualStyle)
            actualStyle = drop.data.styles;
        if (!$requiredIndicatorElement)
            $requiredIndicatorElement = drop.$element;

    	var prefix = classPrefix || 'userstyle-';

        this.mockMode = lq.isInMockMode();
        if (!actualStyle
            || (!this.mockMode && drop.isPeekLayerDrop)
            || (drop.rootDrop && drop.rootDrop.isMockAction && this.mockMode && !drop.isPeekLayerDrop)) {
            var styleId = this.getDefaultStyleIdByDropType(drop);
            if (styleId) {
                var classNameFromStyleId = this.getClassNameFromStyleId(prefix, styleId);
                $actualElement.addClass(classNameFromStyleId);
                $requiredIndicatorElement.addClass(classNameFromStyleId + '-required-indicator');
            }
        } else if (typeof actualStyle === 'string') {
	        var classNameFromStyleId = this.getClassNameFromStyleId(prefix, actualStyle);

	        $actualElement.addClass(classNameFromStyleId);
	        $actualElement.removeClass(customStyleStates.join(' '));

    	    if (customState)
    	        $actualElement.addClass(customState);

            // styling the required indicator -> should always be applied to drop.$element
    	    $requiredIndicatorElement.addClass(classNameFromStyleId.replace(" ", "-") + '-required-indicator');
       	} else {
            var applyDropStyle = function (drop) {
                var layoutId =
                    drop.rootDrop
                    && drop.rootDrop.layout
                        ? drop.rootDrop.layout.id
                        : null;
                // Add new class instead of userstyle, it will be dropStyle
                var classNameFromStyleId = prefix + "custom-" + drop.data.id + (layoutId ? (" " + layoutId) : "");
                $actualElement.addClass(classNameFromStyleId);

                classNameFromStyleId = prefix + "custom-" + drop.data.id + (layoutId ? ("-" + layoutId) : "");
                // styling the required indicator -> should always be applied to drop.$element
                $requiredIndicatorElement.addClass(classNameFromStyleId + '-required-indicator');

                $actualElement.removeClass(customStyleStates.join(' '));
                if (customState)
                    $actualElement.addClass(customState);
            };
            if (drop.data.id) {
                applyDropStyle(drop);
            } else if (drop.designData) {
                // drop does not have an id yet, so was probably just newly added to the canvas
                drop.withOnceDropCreated(applyDropStyle.bind(this, drop));
            }
        }
    };

    Style.prototype.getDefaultStyleIdByDropType = function (drop, ignoreMock) {
        return this.getDefaultStyleIdForComponentByDropType(drop, '', ignoreMock);
    };

    Style.prototype.getDefaultStyleIdForComponentByDropType = function (drop, componentName, ignoreMock) {
        var uncapitalizedComponentName =
            drop.data.type
                .substring(0, 1)
                .toLowerCase()
            + drop.data.type.substring(1)
            + componentName;

        var key = !!drop.data.role ? uncapitalizedComponentName + '_' + drop.data.role : uncapitalizedComponentName;
        if ((!this.mockMode && drop.isPeekLayerDrop)
            || (drop.rootDrop && drop.rootDrop.isMockAction && !ignoreMock && !drop.isPeekLayerDrop))
            return this.defaultMockStyles[key] || this.defaultMockStyles[uncapitalizedComponentName];
        else return this.defaultStyles[key] || this.defaultStyles[uncapitalizedComponentName];
    };

    Style.prototype.getClassNameFromStyleId = function (prefix, styleId) {
        var id = styleId;
        if (styleId.indexOf('/') > -1)
            id = styleId.split('/')[1];
        return prefix + id;
    };

    Style.prototype.removeStyleClass = function (drop, classPrefix, $actualElement) {
    	if (typeof drop.data.styles != 'string')
    	    return;

        if (!$actualElement)
            $actualElement = drop.$element;

        var prefix = classPrefix || 'userstyle-';
        var className = this.getClassNameFromStyleId(prefix, drop.data.styles);
        $actualElement.removeClass(className);
    };

    Style.prototype.getDropTextContent = function ($actualElement) {
        // can be anywhere in the ancestor tree
        if ($actualElement.hasClass('drop-text-container'))
            return $actualElement.find('.drop-text-content');

        // can only be a direct descendant (needed for drops that contain child drops with their own styling)
        return $actualElement
            .children()
            .addBack()
            .filter('.drop-text-content');
    };

    Style.prototype.convertAlignmentValue = function (value) {
        switch(value) {
            case 'top':
            case 'left':
                return 'start';
            case 'middle':
            case 'center':
                return 'center';
            case 'bottom':
            case 'right':
                return 'end';
            default:
                return value;
        }
    }

    Style.prototype.resetCss = function (drop, $actualElement) {
    	$actualElement
            .css({
                borderStyle: '',
                borderColor: '',
                borderTopWidth: '',
                borderBottomWidth: '',
                borderRightWidth: '',
                borderLeftWidth: '',

                fontSize: '',
                fontFamily: '',
                fontWeight: '',
                color: '',
                fontStyle: '',
                textDecoration: '',

                textAlign: '',
                textTransform: '',
                lineHeight: '',

                background: '',

                paddingLeft: '',
                paddingRight: '',
                paddingTop: '',
                paddingBottom: '',

                boxShadow: '',
                textShadow: '',

                opacity: '',

                transform: '',
                filter: '',

                borderTopLeftRadius: '',
                borderTopRightRadius: '',
                borderBottomLeftRadius: '',
                borderBottomRightRadius: '',

                scrollbarGutter: '',
            });

        $actualElement
            .children('.drop-text-content')
            .css({
    	        verticalAlign: ''
    	    });
    };

    Style.prototype.supportedFontFamilies = _.map(defaultSupportedFontFamilies, function(fontFamily) {
        return _.isObject(fontFamily) ? fontFamily.name : fontFamily;
    });

    Style.prototype.defaultFontFamily = Style.prototype.supportedFontFamilies[0];

    Style.prototype.supportedFontFamiliesForPdf = _.chain(defaultSupportedFontFamilies)
        .filter(function(fontFamily) {
            return _.isObject(fontFamily)
        })
        .map(function(fontFamily) {
            return fontFamily.name;
        })
        .value();

    Style.prototype.defaultFontFamilyForPdf = Style.prototype.supportedFontFamiliesForPdf[0];

    Style.prototype.getSupportedFontFamilies = function () {
        return _.sortBy(this.supportedFontFamilies, function (fontName) { return fontName.replace('"', ''); })
            .slice(0); // copy
    };

    Style.prototype.getSupportedFontFamiliesForPdf = function () {
        return _.sortBy(this.supportedFontFamiliesForPdf, function (fontName) { return fontName.replace('"', ''); })
            .slice(0);
    };

    Style.prototype.getSupportedTextTransforms = function () {
        return supportedTextTransforms.slice(0);
    };

    Style.prototype.getSupportedTextAligns = function () {
    	return supportedTextAligns.slice(0);
    };

    Style.prototype.getSupportedFontWeights = function () {
    	return supportedFontWeights.slice(0);
    };

    Style.prototype.getSupportedHorizontalPositions = function () {
        return supportedHorizontalPositions.slice(0);
    };

    Style.prototype.getSupportedVerticalPositions = function () {
        return supportedVerticalPositions.slice(0);
    };

    Style.prototype.getDefaults = function () {
    	return $.extend(true, {}, defaults);
    };

    Style.prototype.bestFontSize = function (container, $text) {
        var successSize = 0;
        var failingSize = 500;
        $text.css('line-height', 'normal');
        while (successSize < (failingSize - 1)) {

            var newFontSize = Math.floor((successSize + failingSize) / 2);
            $text.css('font-size', newFontSize);

            if (container.offsetHeight < container.scrollHeight ||
                container.offsetWidth < container.scrollWidth ||
                container.offsetHeight < $text[0].scrollHeight ||
                container.offsetWidth < $text[0].scrollWidth) {
                failingSize = newFontSize;
            } else {
                successSize = newFontSize;
            }
        }
        $text.css('font-size', successSize);
    };

    return new Style();
});
